import { useEffect } from 'react';
import { useGameStore } from '../store/gameSlice';

/**
 * Mount once, high enough in the tree to live across all screens (MainMenu,
 * hub, dungeon…) and not only while the dungeon is mounted.
 */
export function useScreenSize(): void {
  const setScreenWidth = useGameStore((s) => s.setScreenWidth);
  const setScreenHeight = useGameStore((s) => s.setScreenHeight);

  useEffect(() => {
    const apply = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };
    apply();
    window.addEventListener('resize', apply);
    return () => window.removeEventListener('resize', apply);
  }, [setScreenWidth, setScreenHeight]);
}
